import React from 'react'

export const ArrowDropUp = () => (
  <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 5L5 0L0 5L10 5Z" fill="black" fillOpacity="0.54" />
  </svg>
)
